const phoneRegExp =
/^\(\d{2}\) (?:\d{8}$|(?!2)\d{9}$|\d{7}2$)/

export const phoneRegExpEmpty =
  /^$|^\(\d{2}\) (?:\d{8}$|(?!2)\d{9}$|\d{7}2$)/;
  
export default phoneRegExp;

export const phoneRegExpOld =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;